import { useTranslation } from "react-i18next"
import { useNavigate } from "react-router-dom"
import { useContext, useEffect, useState } from "react"
import { PageHeader } from "../../components/HeaderComponents"
import { FAQHomePage } from "../../components/FAQComponents"
import { darkAndLightThemeDefault } from "../../components/ThemeComponents"
import { HiOutlineExternalLink } from "react-icons/hi"
import { AccountContext } from "../../contexts/AccountContexts"
import { ContentContext } from "../../contexts/ContentContext"


export const UserHomePage = () => {
    const { t } = useTranslation('common')
    const { user } = useContext(AccountContext)
    const { servers } = useContext(ContentContext)

    const [characters, setCharacters] = useState([])

    useEffect(() => {
        console.info("Welcome to Mobile2 Support!")
    }, [])

    useEffect(() => {
        if (user && Object.keys(servers).length > 0) {
            let serverToCharacter_ = {}
            let serverData = Object.values(servers)
            let serverNameToServer = {}
            for (let i = 0; i < Object.keys(servers).length; i++) {
                serverToCharacter_[serverData[i].id] = []
                serverNameToServer[serverData[i].title.toLowerCase()] = serverData[i]
            }
            for (let i = 0; i < user.characters.length; i++) {
                let character = user.characters[i]
                let charServer = serverNameToServer[character.server.toLowerCase()]
                serverToCharacter_[charServer.id].push(character)
            }
            setCharacters(serverToCharacter_)
        }
    }, [user, servers])

    return (
        <>
            <div className="flex flex-col items-center justify-start  py-2  gap-5 pb-10 relative h-full">
                <PageHeader pageTitle={t("Home")} />
                <main className=" flex flex-col justify-start items-center w-full mx-auto max-w-[1280px] z-0 p-1 sm:p-5 gap-3 min-h-screen">
                    <span className="hidden text-lg font-semibold py-3 text-center text-gray-800 dark:text-gray-300">{t("Welcome to Mobile2 Support")}</span>
                    <div className="flex flex-col gap-5 items-center ">

                        <div className="flex flex-col gap-3 justify-center items-center bg-white dark:bg-gray-700 text-gray-800 dark:text-gray-300 p-5 rounded-lg w-full sm:w-[400px]">
                            <span className="text-lg font-semibold py-3 text-center ">{t("Welcome to Mobile2 Support")}</span>

                            <NavButton name={t("Create Ticket")} to={"/member/create-ticket"} />
                            <NavButton name={t("Ticket History")} to={"/member/ticket-history"} />
                        </div>

                        {
                            characters && false &&
                            <div className="flex flex-col gap-3 bg-white dark:bg-gray-700 text-gray-800 dark:text-gray-300 p-5 rounded-lg">
                                <span className="font-semibold text-center">{t("Player's Characters")}</span>

                                <div className="flex gap-6 flex-wrap justify-center">

                                    {
                                        Object.values(servers).sort((a, b) => a.title - b.title).map((server) =>
                                            <div className="flex flex-col items-center gap-3 min-w-32">
                                                <span className="w-20 font-semibold">{server.title}</span>
                                                {

                                                    characters[server.id]?.map((character) =>
                                                        <div className="join">
                                                            <span className="join-item bg-slate-100 dark:bg-slate-600 border dark:border-slate-500 rounded-md text-center px-3 py-0.5">{character.characterName} </span>
                                                            <span className="join-item border dark:border-gray-500 dark:bg-gray-700 rounded-md text-center w-10 p-1 text-sm font-semibold">{character?.characterLevel}</span>
                                                        </div>
                                                    )
                                                }
                                            </div>
                                        )
                                    }
                                </div>
                            </div>
                        }

                    </div>

                    <div className="pt-10 flex flex-col gap-10 sm:grid sm:grid-cols-2 sm:gap-5 px-2 sm:px-0 w-full max-w-[1200px]">
                        <div className="flex flex-col gap-3 text-gray-800 dark:text-gray-300 max-w-max">
                            <span className="text-lg">{t("Useful Links")}</span>
                            <div className="flex flex-col gap-2">
                                <span className="">{t("Transfer your account to safe zone.")}</span>
                                <a href={"https://mobile2.global/transfer"} target="_blank" className={`btn btn-sm max-w-48 ${darkAndLightThemeDefault}`}><HiOutlineExternalLink /> {t("Bug help")}</a>
                            </div>
                            <div className="flex flex-col gap-2">
                                <span className="">{t("Change password of your account here.")}</span>
                                <a href={"https://mobile2.global/pwchange"} target="_blank" className={`btn btn-sm max-w-48 ${darkAndLightThemeDefault}`}><HiOutlineExternalLink /> {t("Change password")}</a>
                            </div>
                            <div className="flex flex-col gap-2">
                                <span className="">{t("Delete the account and in-game characters.")}</span>
                                <a href={"https://mobile2.global/delaccount"} target="_blank" className={`btn btn-sm max-w-48 ${darkAndLightThemeDefault}`}><HiOutlineExternalLink /> {t("Delete account")}</a>
                            </div>
                        </div>
                        <div className="justify-end flex w-full">

                            <FAQHomePage />
                        </div>
                    </div>
                </main>
            </div>
        </>

    )
}


const NavButton = ({ name, to }) => {
    const navigator = useNavigate()

    const handleClick = (e) => {
        e.preventDefault()
        navigator(to)
    }

    return (
        <button className="btn w-full max-w-[300px] bg-white dark:bg-gray-700 text-gray-800 dark:text-gray-300 dark:border-gray-400 dark:hover:border-gray-500 hover:bg-primary hover:text-white" onClick={handleClick}>{name}</button>
    )
}